import React from "react";
import { Progress } from "antd";
import { AppButton } from "components/button/AppButton";
import avatar from "assets/images/default.webp";
import { useNavigate } from "react-router-dom";

interface ProfileCompletionCardProps {
    photo?: string | null;
    total?: number;
    onClick?: () => void;
}

const ProfileCompletionCard: React.FC<ProfileCompletionCardProps> = ({
  photo,
  total = 0,
  onClick,
}) => {
  const navigate = useNavigate();

  // color logic based on completion %
  const getStrokeColor = (value: number) => {
    if (value === 100) return "#65DE02";
    if (value >= 90) return "#3CB371";
    if (value >= 80) return "#FFBF00";
    if (value >= 70) return "#FF8C00";
    if (value >= 60) return "#FF6347";
    return "#FF0000";
  };

  return (
    <div className="bg-white mx-auto px-3 py-4 rounded-lg shadow-sm mt-4">
      <img
        src={photo || avatar}
        alt="avatar"
        className="h-12 w-12 rounded-full mb-2"
      />

      <div className="flex flex-row items-center">
        <h1 className="text-xs font-bold mb-4">Complete your Profile!</h1>

        {/* spacer */}
        <div className="flex-1" />

        <div className="mr-4">
          <Progress
            type="circle"
            percent={total}
            strokeColor={getStrokeColor(total)}
            strokeWidth={10}
            size={55}
            format={() => null}
          />
        </div>
      </div>

      <p className="text-gray-700 mb-8 text-xs">
        Complete your profile to finish setting up your account.
      </p>

      <AppButton
        type="button"
        label="Complete Now"
        handleClick={onClick || (() => navigate("/settings"))}
      />
    </div>
  );
};

export default ProfileCompletionCard;
